<template>
    <CardDivisorioGrigio>
        <template v-slot:top>
            <div class="flex flex-shrink px-2 text-white rounded" :class="coloreStatoClass">{{ siglaStato }}</div>
            <div class="flex flex-shrink ml-3 ">{{ stato }}</div>
        </template>
        <template v-slot:bottom>
            <div class="flex flex-shrink self-center border border-next-neu px-2 rounded box-border ">{{ siglaProgetto }}</div>
            <div class="flex flex-shrink self-center ml-3">{{ progetto }}</div>
        </template>
    </CardDivisorioGrigio>




</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import CardDivisorioGrigio from "@/components/CardDivisorioGrigio.vue";

@Options({
    name:'StatoCard',
    components: {CardDivisorioGrigio},
    props: {
        siglaProgetto: String,
        progetto: String,
        siglaStato: String,
        stato: String,
        coloreStatoClass: String,
    }
})
export default class StatoCard extends Vue {
    siglaProgetto!: string
    progetto!: string
    siglaStato!: string
    stato!: string
    coloreStatoClass!: string
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
